<template>
    <el-dialog
        class="my-coupon"
        :visible.sync="couponListVisible"
        :close-on-click-modal="false"
        @closed="closeDialog"
        width="1000px"
        title="My Coupon"
        :lock-scroll="false"
        :modal-append-to-body="false"
        append-to-body
    >
        <div class="container">
            <status-tabs
                :status.sync="status"
                :statusList="statusList"
                :funcName="funcName"
            ></status-tabs>
            <el-table
                :data="tableData"
                ref="tableData"
                row-key="id"
                align="left"
                style="width: 100%"
                header-cell-class-name="header-cell-class-name"
                cell-class-name="cell-class-name"
            >
                <el-table-column
                    label="Name"
                    prop="name"
                    show-overflow-tooltip
                ></el-table-column>
                <el-table-column label="Value">
                    <template slot-scope="scoped">
                        <p>{{ scoped.row.value }}</p>
                    </template>
                </el-table-column>
                <el-table-column
                    label="Desc"
                    prop="desc"
                    show-overflow-tooltip
                ></el-table-column>
                <el-table-column
                    label="Start Time"
                    prop="start_time"
                    width="180"
                >
                </el-table-column>
                <el-table-column label="End Time" prop="end_time" width="180">
                </el-table-column>
                <el-table-column label="Status" width="140">
                    <template slot-scope="scope">
                        <span
                            class="general-table-tag"
                            :class="[
                                scope.row.status == 1
                                    ? 'success'
                                    : scope.row.status == 5 || scope.row.status == 10
                                    ? 'info'
                                    : '',
                            ]"
                        >
                            <i class="el-icon-s-help"></i>
                            {{ scope.row.status_name }}
                        </span>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button
                size="small"
                type="primary"
                @click="couponListVisible = false"
                >Close</el-button
            >
        </span>
    </el-dialog>
</template>

<script>
import statusTabs from "@/common/components/table/status_tabs.vue";
import { cmofferApi } from "@/http/cmofferApi.js";
export default {
    data() {
        return {
            tableData: [],
            status: "0",
            funcName: "userCoupon",
            statusList: [
                {
                    name: "All",
                    status: "0",
                },
                {
                    name: "Normal",
                    status: "1",
                },
                {
                    name: "Used",
                    status: "2",
                },
                {
                    name: "Invalid",
                    status: "3",
                },
            ],
        };
    },
    methods: {
        closeDialog() {
            this.$emit("update:couponListVisible", false);
        },
        async initialize() {
            this.userCoupon();
        },
        userCoupon() {
            cmofferApi
                .userCoupon({ status: this.status }, "get")
                .then((res) => {
                    if (res) {
                        // console.log(res);
                        this.tableData = res.data;
                        this.statusList = res.ext.tabs;
                    }
                });
        },
    },
    props: {
        couponListVisible: Boolean,
    },
    watch: {
        couponListVisible() {
            if (this.couponListVisible) {
                this.initialize();
            }
        },
    },
    components: {
        statusTabs,
    },
};
</script>

<style lang="scss" scoped>
.my-coupon {
    ::v-deep .container {
        .header-cell-class-name {
            font-size: 13px;
            background-color: transparent;
            color: $color-333333 !important;
            text-align: center;
        }
        .cell-class-name {
            font-size: 13px;
            vertical-align: top;
            text-align: center;
            .el-button--mini {
                color: $color-primary-blue;
                &:active {
                    opacity: 0.6;
                }
            }
            &:nth-child(1) {
                .cell {
                    padding-left: 15px;
                }
            }
        }
    }
}
</style>
